import { ActionTypes } from '../../constants/ActionTypes';
//FAST ARCHIVE
export const onGetEmployeePositionFastArchive = () => {
  return {
    type: ActionTypes.GET_EMPLOYEE_POSITION_FAST_ARCHIVE,
  };
};

export const fetchEmployeePositionFastArchiveSuccess = (
  fastArchiveEmployeePosition: any,
) => {
  return {
    type: ActionTypes.FETCH_EMPLOYEE_POSITION_FAST_ARCHIVE_SUCCESS,
    payload: fastArchiveEmployeePosition,
  };
};

/*********************************************/
export const onGetEmployeePositionFastRefers = () => {
  return {
    type: ActionTypes.GET_EMPLOYEE_POSITION_FAST_REFERS,
  };
};

export const fetchEmployeePositionFastRefersSuccess = (
  fastRefersEmployeePosition: any,
) => {
  return {
    type: ActionTypes.FETCH_EMPLOYEE_POSITION_FAST_REFERS_SUCCESS,
    payload: fastRefersEmployeePosition,
  };
};

export const onGetEmployeePositionReferText = (search?: string) => {
  return {
    type: ActionTypes.GET_EMPLOYEEPOSITION_REFER_TEXT,
    payload: search,
  };
};

export const fetchEmployeePositionReferTextSuccess = (
  referText: any[],
  search?: string,
) => {
  return {
    type: ActionTypes.FETCH_EMPLOYEEPOSITION_REFER_TEXT_SUCCESS,
    payload: {
      resultReferText: referText,
      search: search,
    },
  };
};

/*********************************************/
export const onChangeEmployeePosition = () => {
  return (dispatch: any) => dispatch({ type: ActionTypes.DESTROY_SESSION });
};
